export default __webpack_public_path__ + "static/media/slider_image3.a81b7a36.jpg";